import { Content, Horizontal } from "gls";
import { Column } from "../DataTable"
import { classes, style } from "typestyle";
import { colours, coloursNames } from "styling/colours";
import { icons } from "assets/icons";
import { isString } from "lodash";

type THeadCellProps<T> = {
  column: Column<T>,
  onSort?: (field: string) => void;
};

export const TableHeaderCell = <T,>({ column, onSort }: THeadCellProps<T>) => {

  const handleSort = () => {
    !column.noSort && onSort && onSort(column.sortField || column.field)
  }
  const ariaLabel = isString(column.title) && column.title !== ""
    ? column.title
    : (column.ariaLabel || "Actions")
  return (
    <th
      aria-label={ariaLabel}
      role={column.noSort ? "" : "button"}
      tabIndex={column.noSort ? -1 : 0}
      className={classes(tHeadCellStyle(column.width, !column.noSort), column.className)}
      onClick={column.noSort ? undefined : handleSort}
      onKeyDown={e => {
        if (!column.noSort && e.key === "Enter")
          handleSort()
      }}
    >
      <Horizontal
        verticalAlign="center"
        spacing="5px"
        style={{ marginRight: "15px" }}
      >
        {column.title &&
          <Content className={tContentStyle}>
            {column.title}
          </Content>
        }
        {!column.noSort && (
          <icons.SortIcon aria-label={`Sort by ${column.title}`} width={20} fill={colours.primary} />
        )}
      </Horizontal>
    </th>
  );
};

const tHeadCellStyle = (width?: string, isSortable = false) => style({
  width: width ?? "auto",
  minWidth: width ?? "auto",
  cursor: isSortable ? "pointer" : "auto",
  $nest: {
    "&:hover": {
      color: isSortable ? colours.secondary : "auto",
      $nest: {
        "svg": {
          fill: colours.secondary,
        },
        "div": {
          borderColor: colours.secondary,
        }
      }
    },
    "&:focus-visible": {
      outline: `1px solid ${coloursNames.deepSkyBlue}`,
      outlineOffset: "-1px"
    }
  }
});

const tContentStyle = style({
  display: "block",
  width: "max-content",
});

